var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "copyArea"
  }, [_vm._m(0), _c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "value-key": "id",
      "filterable": "",
      "clearable": "",
      "placeholder": "-- Select an existing data to copy --"
    },
    on: {
      "change": _vm.copyFromHandle
    },
    model: {
      value: _vm.copyFromExist,
      callback: function callback($$v) {
        _vm.copyFromExist = $$v;
      },
      expression: "copyFromExist"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c('el-option', {
      key: "copy-from-".concat(item.id),
      attrs: {
        "label": _vm.getLabel(item),
        "value": item
      }
    });
  }), 1)], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('span', {
    staticClass: "fs14 fwb el-icon-document-copy"
  }), _c('span', {
    staticClass: "fs13 ml2"
  }, [_vm._v("Copy from existing:")])]);
}]

export { render, staticRenderFns }